/**
 * Map a lookup LIST route (plural slug) to its CREATE route (singular, no id).
 * CRX routing convention is 100% mechanical: list = plural (e.g. "/currencies",
 * "/equipment-types", "/countries"), create = singular-with-no-id ("/currency",
 * "/equipment-type", "/country"), edit = singular + ":id".
 *
 * Two transforms cover every CRX lookup slug:
 *   "...ies" -> "...y"  (currencies->currency, countries->country, cities->city,
 *                        specialties->specialty, capabilities->capability)
 *   "...s"   -> "..."   (equipment-types->equipment-type, leg-types->leg-type,
 *                        tags->tag, states->state, languages->language,
 *                        timezones->timezone, regions->region, services->service,
 *                        manufacturers->manufacturer, colors->color, ...)
 *
 * Only the FIRST path segment is singularised; a leading slash and any trailing
 * segments are preserved. For irregular/nested create routes (e.g. a sub-service
 * that needs a parent id) pass an explicit `createPageUrl` at the call-site
 * instead of relying on this derivation.
 */
export const lookupCreateUrl = (listUrl: string | null | undefined): string => {
    if (!listUrl) return listUrl ?? "";
    const lead = listUrl.startsWith("/") ? "/" : "";
    const parts = listUrl.replace(/^\/+/, "").split("/");
    let first = parts[0] ?? "";
    if (first.endsWith("ies")) first = first.slice(0, -3) + "y";
    else if (first.endsWith("s")) first = first.slice(0, -1);
    parts[0] = first;
    return lead + parts.join("/");
};
